<template>
  <div id="partnership">
    <Navbar />
    <JoinIB v-if="!userIB" />
    <div class="container mt-5 mb-5" v-if="userIB">
      <!-- Page Title -->
      <h1 class="text-center mb-5 txt-title">Partnership</h1>

      <div class="row">
        <!-- My Info Card -->
        <div class="col-lg-5 mb-4">
          <div class="card shadow-sm h-100">
            <div class="card-body">
              <h3 class="card-title txt-bold mb-4">My Info</h3>

              <!-- IB Name & Referral ID -->
              <div class="row mb-3">
                <div class="col-6">
                  <p class="text-muted mb-1">IB Name</p>
                  <h5 class="txt-bold">{{ userData.name || 'Maria Imaculata' }}</h5>
                </div>
                <div class="col-6">
                  <p class="text-muted mb-1">Referral Id:</p>
                  <h5 class="txt-bold">{{ userData.referral_code || '525KCHPY4WR2' }}</h5>
                </div>
              </div>

              <!-- Partnership Level -->
              <div class="mb-4">
                <p class="text-muted mb-1">Partnership</p>
                <h5 class="txt-bold">{{ userData.partnership || 'MASTER IB' }}</h5>
              </div>

              <!-- Referral Link -->
              <div>
                <p class="text-muted mb-2">Referral Link:</p>
                <div class="input-group">
                  <input type="text" class="form-control bg-white txt-bold" :value="referralLink" readonly
                    ref="referralInput">
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" @click="copyReferralLink"
                      :title="copyTooltip">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                        viewBox="0 0 16 16">
                        <path
                          d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                        <path
                          d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Generate Rebate Card -->
        <div class="col-lg-7 mb-4">
          <div class="card shadow-sm h-100">
            <div class="card-body">
              <h3 class="card-title txt-bold mb-4">Generate rebate data</h3>

              <!-- Date Range -->
              <div class="row mb-3 input-group ">
                <div class="col-md-6 mb-3 mb-md-0">
                  <label class="form-label txt-bold">Start Date:</label>
                  <input type="date" class="form-control" v-model="filter.startDate">
                </div>
                <div class="col-md-6">
                  <label class="form-label txt-bold">End Date:</label>
                  <input type="date" class="form-control" v-model="filter.endDate">
                </div>
              </div>

              <!-- Show Only Filter -->
              <div class="input-group row mb-4">
                <div class="col-md-6 mb-3 mb-md-0">
                  <label class="form-label txt-bold">Show Only</label>
                  <select class="form-control" v-model="filter.showOnly">
                    <option value="all">All Data</option>
                    <option value="network">Network Only</option>
                    <option value="direct">Direct Only</option>
                  </select>
                </div>
                <div class="col-md-6 d-flex align-items-end">
                  <button class="btn btn-blue txt-bold w-100 py-2" @click="generateRebate" :disabled="loading">
                    <span v-if="loading" class="d-flex align-items-center justify-content-center">
                      <span class="spinner-border spinner-border-sm mr-2"></span>
                      Loading...
                    </span>
                    <span v-else>Generate Rebate</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Rebate Data Card -->
      <div class="card shadow-sm">
        <div class="card-body">
          <h3 class="card-title txt-bold mb-4">Rebate Data</h3>

          <!-- Summary Stats -->
          <div class="row mb-4">
            <div class="col-md-4 mb-3 mb-md-0">
              <div class="stats-box p-3 bg-light">
                <p class="text-muted mb-1">Total Network:</p>
                <h4 class="txt-bold mb-0">{{ rebateData.totalNetwork }}</h4>
              </div>
            </div>
            <div class="col-md-4 mb-3 mb-md-0">
              <div class="stats-box p-3 bg-light">
                <p class="text-muted mb-1">Total Rebate:</p>
                <h4 class="txt-bold mb-0">${{ rebateData.totalRebate.toFixed(2) }}</h4>
              </div>
            </div>
            <div class="col-md-4">
              <div class="stats-box p-3 bg-light">
                <p class="text-muted mb-1">Total Volume:</p>
                <h4 class="txt-bold mb-0">{{ rebateData.totalVolume.toFixed(2) }}</h4>
              </div>
            </div>
          </div>

          <!-- Search & Download -->
          <div class="row mb-3">
            <div class="col-md-8 mb-3 mb-md-0">
              <label class="form-label">Search Rebate Data by Name</label>
              <div class="search-input-wrapper">
                <input type="text" class="form-control search-input-with-icon" placeholder="search rebate data here"
                  v-model="searchInput" @input="onSearchInput">
                <i class="fa fa-search search-icon-inside"></i>
              </div>
            </div>
            <div class="col-md-4 d-flex align-items-end">
              <button class="btn btn-blue txt-bold w-100 py-2" @click="downloadReport">
                Download Report
              </button>
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive">
            <table class="table table-hover rounded">
              <thead class="thead-light">
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Account ID</th>
                  <th>Level</th>
                  <th>Rebate ($)</th>
                  <th>Volume (lot)</th>
                  <!-- <th>Action</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td colspan="7" class="text-center py-5">
                    <div class="spinner-border txt-blue" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </td>
                </tr>
                <tr v-else-if="filteredRebateList.length === 0">
                  <td colspan="7" class="text-center py-5">
                    <img src="/assets/img/empty-state.svg" alt="No data" style="max-width: 150px; opacity: 0.5;"
                      class="mb-3">
                    <p class="text-muted">No rebate data available</p>
                  </td>
                </tr>
                <tr v-else v-for="item in paginatedList" :key="item.account">
                  <td class="txt-bold">{{ item.user.name }}</td>
                  <td>{{ item.user.email }}</td>
                  <td class="txt-bold">{{ item.account }}</td>
                  <td>
                    <span class="badge badge-primary">Level {{ item.level }}</span>
                  </td>
                  <td class="txt-bold text-success">${{ truncate(item.rebate) }}</td>
                  <td>{{ truncate(item.volume) }}</td>
                  <!-- <td>
                    <button class="btn btn-sm btn-outline-primary" @click="viewDetail(item)">
                      View
                    </button>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <nav v-if="filteredRebateList.length > 0" aria-label="Page navigation">
            <ul class="pagination justify-content-end mb-0">
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="currentPage--">Previous</a>
              </li>
              <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
                <a class="page-link" href="#" @click.prevent="currentPage = page">{{ page }}</a>
              </li>
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="currentPage++">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import axios from 'axios'
import Notiflix from 'notiflix'
import JoinIB from '../components/JoinIB.vue'

// const url = process.env.VUE_APP_API_URL
const forexcrm = process.env.VUE_APP_FOREXCM
const token = process.env.VUE_APP_API_TOKEN

export default {
  name: "partnership",
  components: {
    Navbar,
    JoinIB
  },
  data() {
    return {
      userData: null,
      filter: {
        startDate: new Date(new Date().getFullYear(), 0, 1).toISOString().split('T')[0],
        endDate: new Date().toISOString().split('T')[0],
        showOnly: 'all'
      },
      searchInput: '',
      activeSearchQuery: '',
      rebateData: {
        totalNetwork: 0,
        totalRebate: 0.00,
        totalVolume: 0.00
      },
      rebateList: [],
      rebateListFiltered: [],
      userRebatesChilds: [],
      loading: false,
      currentPage: 1,
      itemsPerPage: 10,
      searchDebounceId: null,
      copyTooltip: 'Copy to clipboard',
      userIB: false
    }
  },
  computed: {
    referralLink() {
      const code = this.userData?.referral_code || '';
      return `${window.location.origin}/signup?referral=${encodeURIComponent(code)}`;
    },
    startDateISO() {
      // Convert YYYY-MM-DD to ISO string for GraphQL
      return this.filter.startDate ? new Date(this.filter.startDate + 'T00:00:00.000Z').toISOString() : '';
    },
    endDateISO() {
      // Convert YYYY-MM-DD to ISO string for GraphQL
      return this.filter.endDate ? new Date(this.filter.endDate + 'T23:59:59.999Z').toISOString() : '';
    },
    filteredRebateList() {
      let filtered = [...this.rebateListFiltered];

      // Apply search filter
      if (this.activeSearchQuery.trim()) {
        const query = this.activeSearchQuery.toLowerCase();
        filtered = filtered.filter(item =>
          item.user.name.toLowerCase().includes(query)
        );
      }

      return filtered;
    },
    paginatedList() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredRebateList.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredRebateList.length / this.itemsPerPage);
    }
  },
  watch: {
    'filter.showOnly'() {
      // Re-apply level filter and reset pagination when filter changes
      this.applyShowOnlyFilter();
      this.currentPage = 1;
    }
  },
  created() {
    localStorage.setItem("pageNow", "partnership");
    this.initUserData();
  },
  mounted() {
    this.fetchRebateData();
  },
  methods: {
    initUserData() {
      const userDataStr = localStorage.getItem("userData");
      if (!userDataStr) {
        this.$router.push('/login');
        return;
      }

      try {
        const userData = JSON.parse(userDataStr);
        this.userData = {
          name: userData.user?.name || '',
          email: userData.user?.email || '',
          referral_code: userData.user?.referral_code || '',
          role: userData.user?.role || 'USER_TRADER',
          token: userData.token
        };

        this.userIB = this.userData.role !== "USER_TRADER";

        if (!this.userIB) {
          this.$router.push('/join-ib');
        }
      } catch (error) {
        console.error('Error parsing userData:', error);
        this.$router.push('/login');
      }
    },

    async fetchRebateData() {
      if (!this.userData?.token) {
        Notiflix.Notify.failure('Authentication required');
        return;
      }

      this.loading = true;

      try {
        const options = {
          method: 'POST',
          url: `${forexcrm}/v1/graphql`,
          headers: {
            'Content-Type': 'application/json',
            'X-APP-TOKEN': token,
            'X-USER-TOKEN': this.userData.token,
          },
          data: {
            query: `{
              RebateUser(input: {
                params: {
                  date_from: "${this.startDateISO}"
                  date_to: "${this.endDateISO}"
                  email: "${this.userData.email}"
                }
              }) {
                user {
                  name
                  email
                }
                total_rebate
                total_volume
                childrens {
                  user {
                    name
                    email
                  }
                  account
                  level
                  volume
                  rebate
                  commission
                }
                childs {
                  user {
                    name
                    email
                  }
                  total_childrens
                }
              }
            }`
          }
        };

        const response = await axios.request(options);
        const rebateUser = response.data?.data?.RebateUser?.[0];

        if (rebateUser) {
          // Sort by level
          const childrens = rebateUser.childrens || [];
          childrens.sort((a, b) => a.level - b.level);

          this.rebateList = childrens;
          this.userRebatesChilds = rebateUser.childs || [];

          // Update summary
          this.rebateData = {
            totalNetwork: childrens.length,
            totalRebate: rebateUser.total_rebate || 0,
            totalVolume: rebateUser.total_volume || 0
          };

          // Apply filter
          this.applyShowOnlyFilter();
        } else {
          this.resetData();
        }
      } catch (error) {
        console.error('Error fetching rebate data:', error);

        if (error.response?.status === 401 || error.response?.status === 403) {
          Notiflix.Notify.failure('Session expired. Please login again.');
          localStorage.removeItem('userData');
          localStorage.removeItem('isLogin');
          this.$router.push('/login');
        } else {
          Notiflix.Notify.failure('Failed to load rebate data');
          this.resetData();
        }
      } finally {
        this.loading = false;
      }
    },

    applyShowOnlyFilter() {
      let filtered = [...this.rebateList];

      if (this.filter.showOnly === 'direct') {
        filtered = filtered.filter(item => item.level === 1);
      } else if (this.filter.showOnly === 'network') {
        filtered = filtered.filter(item => item.level > 1);
      }

      this.rebateListFiltered = filtered;
      this.currentPage = 1;
    },

    resetData() {
      this.rebateList = [];
      this.rebateListFiltered = [];
      this.userRebatesChilds = [];
      this.rebateData = {
        totalNetwork: 0,
        totalRebate: 0,
        totalVolume: 0
      };
    },

    generateRebate() {
      // Validate dates
      if (!this.filter.startDate || !this.filter.endDate) {
        Notiflix.Notify.failure('Please select both start and end dates');
        return;
      }

      if (new Date(this.filter.startDate) > new Date(this.filter.endDate)) {
        Notiflix.Notify.failure('Start date cannot be after end date');
        return;
      }

      this.currentPage = 1;
      this.searchInput = '';
      this.activeSearchQuery = '';
      this.fetchRebateData();
    },

    onSearchInput() {
      // Debounce 500ms before applying search
      if (this.searchDebounceId) {
        clearTimeout(this.searchDebounceId);
      }
      this.searchDebounceId = setTimeout(() => {
        this.searchRebate();
      }, 500);
    },

    searchRebate() {
      this.activeSearchQuery = (this.searchInput || '').trim();
      this.currentPage = 1;
    },

    copyReferralLink() {
      if (!this.$refs.referralInput) return;

      this.$refs.referralInput.select();

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.referralLink)
          .then(() => {
            this.showCopySuccess();
          })
          .catch(() => {
            document.execCommand('copy');
            this.showCopySuccess();
          });
      } else {
        document.execCommand('copy');
        this.showCopySuccess();
      }
    },

    showCopySuccess() {
      this.copyTooltip = 'Copied!';
      Notiflix.Notify.success('Referral link copied to clipboard');

      setTimeout(() => {
        this.copyTooltip = 'Copy to clipboard';
      }, 2000);
    },

    viewDetail(item) {
      Notiflix.Report.info(
        'Rebate Detail',
        `Name: ${item.user.name}<br>
         Email: ${item.user.email}<br>
         Account ID: ${item.account}<br>
         Level: ${item.level}<br>
         Rebate: $${this.truncate(item.rebate)}<br>
         Volume: ${this.truncate(item.volume)} lots<br>
         Commission: $${this.truncate(item.commission || 0)}`,
        'Close'
      );
    },

    async downloadReport() {
      if (!this.filter.startDate || !this.filter.endDate) {
        Notiflix.Notify.failure('Please select date range');
        return;
      }

      try {
        Notiflix.Loading.standard('Generating report...');

        // Generate CSV from filtered data
        const headers = ['Name', 'Email', 'Account ID', 'Level', 'Rebate ($)', 'Volume (lot)', 'Commission ($)'];
        const csvData = [
          headers.join(','),
          ...this.filteredRebateList.map(item =>
            `"${item.user.name}","${item.user.email}",${item.account},${item.level},${this.truncate(item.rebate)},${this.truncate(item.volume)},${this.truncate(item.commission || 0)}`
          )
        ].join('\n');

        // Add summary
        const summary = `\n\nSummary\nTotal Network,${this.rebateData.totalNetwork}\nTotal Rebate,$${this.truncate(this.rebateData.totalRebate)}\nTotal Volume,${this.truncate(this.rebateData.totalVolume)}`;
        const finalCsv = csvData + summary;

        // Create download
        const blob = new Blob([finalCsv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `rebate_report_${this.filter.startDate}_${this.filter.endDate}.csv`;
        link.click();

        Notiflix.Notify.success('Report downloaded successfully');
      } catch (error) {
        console.error('Error downloading report:', error);
        Notiflix.Notify.failure('Failed to download report');
      } finally {
        Notiflix.Loading.remove();
      }
    },

    truncate(value) {
      const num = parseFloat(value) || 0;
      return (Math.floor(num * 100) / 100).toFixed(2);
    },

    goToChild(userEmail) {
      // Handle navigation to child rebate data
      // This would typically route to a new page or update the current view
      console.log('Navigate to child:', userEmail);
    }
  }
}
</script>

<style scoped>
#partnership {
  min-height: 100vh;
  padding-bottom: 3rem;
  margin-top: 100px;
}

.card {
  border: none;
  border-radius: 12px;
  background-color: #fafafa;
}

.card .card-title {
  font-size: 1.5rem;
}

.stats-box {
  border: 2px solid #d3d3d3;
  border-radius: 12px;
  padding: 1.5rem;
}

.stats-box p {
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
}

.stats-box h4 {
  font-size: 1.75rem;
  color: #333;
}

.table th {
  font-weight: 600;
  border-top: none;
  color: #666;
}

.table td {
  vertical-align: middle;
}

.badge-primary {
  background-color: #c09a07;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
}

.pagination .page-item.active .page-link {
  background-color: #c09a07;
  border-color: #c09a07;
  color: #fafafa;
}

.pagination .page-link {
  color: #333;
}

.pagination .page-link:hover {
  color: #666;
}

.input-group .form-control {
  margin-right: 8px;
  padding: 6px 16px;
  border: 2px solid #d3d3d3;
  border-radius: 12px;
}

.search-input-wrapper {
  position: relative;
  width: 100%;
}

.search-input-with-icon {
  padding-right: 8px;
  padding-left: 42px !important;
  border: 2px solid #d3d3d3;
  border-radius: 12px;
}

.search-icon-inside {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #c09a07;
  font-size: 18px;
  pointer-events: none;
}

.search-icon-append {
  background-color: #c09a07;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
}

@media (max-width: 768px) {
  .card-title {
    font-size: 1.25rem !important;
  }

  .table {
    font-size: 0.875rem;
  }
}
</style>
